import { API_URL } from 'core/infra/environment'
import { NotFoundError } from 'core/infra/errors/NotFoundError'
import { HttpClient } from 'core/infra/http/HttpClient'

import { sentry } from 'legacy/utils/sentry'

import { type PreferredLane } from '../domain/PreferredLane'
import { PreferredLaneRepository } from '../infra/PreferredLaneRepository'

export type CheckPreferredLaneExistenceDeps = {
  repository: PreferredLaneRepository
}

export function checkPreferredLaneExistenceFactory({
  repository,
}: CheckPreferredLaneExistenceDeps) {
  return async function checkPreferredLaneExistenceImpl(
    preferredLane: PreferredLane,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await repository.getByPreferredLane(preferredLane, config)
    } catch (error) {
      if (error instanceof NotFoundError) {
        throw error
      }

      const newError = new Error('Could not check if preferred lane exists', { cause: error })
      sentry.log(newError)
      throw newError
    }
  }
}

export function checkPreferredLaneExistence(
  preferredLane: PreferredLane,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new HttpClient(API_URL)
  const repository = new PreferredLaneRepository({ httpClient })
  const newCheckPreferredLaneExistence = checkPreferredLaneExistenceFactory({ repository })

  return newCheckPreferredLaneExistence(preferredLane, config)
}
